import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef, useEffect } from 'react';
import { borderColors } from '@sphereon/ui-components.core';
import DropDownListItem from '../DropDownListItem';
import SSIIconButton from '../../buttons/SSIIconButton';
import { DropDownListContainerStyled as Container, DropDownContainerStyled as DropDownContainer, DropDownListButtonStyled as ListButton, } from '../../../styles/components';
const DropDownList = (props) => {
    const { icon, buttons, showBorder = false } = props;
    const [showActionsMenu, setShowActionsMenu] = useState(false);
    const dropdownRef = useRef(null);
    const onMore = (event) => {
        setShowActionsMenu(!showActionsMenu);
        event.stopPropagation();
    };
    useEffect(() => {
        const onClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowActionsMenu(false);
            }
        };
        document.addEventListener('mousedown', onClickOutside);
        return () => {
            document.removeEventListener('mousedown', onClickOutside);
        };
    }, [showActionsMenu]);
    const getItems = () => {
        return buttons.map((item, index) => {
            const showBorder = buttons.length > 1 && index !== buttons.length - 1;
            return (_jsx(DropDownListItem, { showBorder: showBorder, label: item.caption, onClick: item.onClick, icon: item.icon, fontColor: item.fontColor }, index));
        });
    };
    return (_jsxs(Container, { ref: dropdownRef, children: [_jsx(ListButton, { children: _jsx(SSIIconButton, { icon: icon, onClick: onMore }) }), showActionsMenu && _jsx(DropDownContainer, { style: { ...(showBorder && { borderWidth: 2, borderColor: borderColors.lightGrey, borderStyle: 'solid' }) }, children: getItems() })] }));
};
export default DropDownList;
